import { api } from "./client";

export const emptyProfile = {
  name:     "",
  tagline:  "",
  phone:    "",
  email:    "",
  whatsapp: "",
  location: "",
  hours:    "",
  about:    "",
};

export async function getProfile() {
  const { profile } = await api.get("/profile", { auth: true });
  return profile || null;
}

export async function isSetupComplete() {
  // Delegated to auth.js; re-exported here for backwards compatibility.
  const { complete } = await api.get("/auth/setup");
  return Boolean(complete);
}

export async function createProfile(_adminUid, profile) {
  const { profile: saved } = await api.put("/profile", { ...emptyProfile, ...profile }, { auth: true });
  return saved;
}

export async function updateProfile(profile) {
  const { profile: saved } = await api.put("/profile", profile, { auth: true });
  return saved;
}
